module.exports = __webpack_public_path__ + "static/media/login_logo_colorida.6bd4a5be.png";